import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import close_img from '../../assets/close.svg';

export default function NiceModal(props) {
  const {
    onClose = () => {},
    zIndex = 200,
    canClose = true,
    closeOnEsc = true,
    closeOnOutsideClick = true, 
    withBlurBackground = true,
    customCloseButton,
    children
  } = props;

  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  const handleKeyPress = (evt) => {
    if (evt.keyCode === 27 && canClose && closeOnEsc) {
      onClose();
    }
  };

  useEffect(() => {
    const originalPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    document.body.style.overflow = 'hidden';

    document.addEventListener('keydown', handleKeyPress);
    if (canClose && closeOnOutsideClick) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      if (canClose && closeOnOutsideClick) {
        document.removeEventListener('mousedown', handleClickOutside);
      }
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = originalPaddingRight;
    };
  }, []);

  return (
    <Wrapper zIndex={zIndex} tabIndex={-1} withBlurBackground={withBlurBackground}>
      <Box ref={modalRef} tabIndex={0}>
        {canClose && (
          customCloseButton ? (
            React.cloneElement(customCloseButton, {
              children: (
                <CloseIcon
                  alt="close"
                  src={close_img}
                  onClick={onClose}
                />
              )
            })
          ) : (
            <TopBox>
              <CloseIcon
                alt="close"
                src={close_img}
                onClick={onClose}
              />
            </TopBox>
          )
        )}
        <ContentPlaceholder>{children}</ContentPlaceholder>
      </Box>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  z-index: ${props => (props.zIndex == undefined ? 10 : props.zIndex)};
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: ${props => props.withBlurBackground ? 'rgba(51, 51, 51, 0.6)' : 'transparent'};
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  justify-content: center;
`;

const Box = styled.div`
  box-sizing: border-box;
  background: rgba(29, 29, 29, 1);
  position: relative;
  color: white;
  border-radius: 12px;

  @media (max-width: 400px) {
    width: calc(100vw - 24px);
    margin: 12px 0;
    box-sizing: border-box;
  }
`;

const TopBox = styled.div`
  position: absolute;
  right: 24px;
  top: 24px;
`;

const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;

  @media (max-width: 720px) {
    z-index: 11;
  }
`;

const ContentPlaceholder = styled.div`
  font-family: Nunito Sans !important;
  max-height: calc(100vh - 24px);
  overflow: auto;

  @media (max-width: 400px) {
    max-height: calc(100vh - 24px);
    overflow: auto;
  }
`;